import elementDatasetPolyfill from 'element-dataset'

elementDatasetPolyfill()
